export default {
  title: 'Notificaciones factura',
  new: {
    title: 'Nueva delegación',
    single: 'Delegación',
    action: 'Añadir configuración'
  },
  provider: 'Email proveedor',
  acc: {
    first: 'Avisos de facturas a cobrar',
    second: 'Avisos de autofacturas a cobrar',
    third: 'Avisos de facturas a pagar',
    fourth: 'Avisos de autofacturas a pagar'
  },
  copy: 'Copiar configuración de la factura',
  form: {
    language: 'Idioma',
    email: 'Correo electrónico*',
    emited: 'Cuando es emitida',
    read: 'Cuando es leida',
    accepted: 'Cuando es aceptada',
    refused: 'Cuando es rechazada',
    edited: 'Cuando es rectificada',
    ignored: 'Al no ser leida en 7 días'
  },
  delete: {
    title: 'Listado de notificaciones para eliminar',
    success: 'Las notificaciones fueron eliminadas con éxito.'
  },
  errors: {
    title: 'Por favor, revise los siguientes datos',
    unavailable: 'No se puede crear un nuevo aviso ya que todas las delegaciones de la Entidad Adscrita tienen avisos configurados',
    setup: 'Error en la configuración de las notificaciones.'
  }
}
